const randomUuid = ()=>{
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
      return v.toString(16);
    });
  } 
const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

const encode = raw =>{
  return raw?raw.replace(/\|/g,"||").replace(/\//g,"|").replace("%2F", "|"):"";
}




const processLink=(url,type)=>{
	const urlTemplate={
		cve: "https://cve.mitre.org/cgi-bin/cvename.cgi?name=",
		nvd: "https://nvd.nist.gov/vuln/detail/"
	}
	if(!type) return url;
	if(type.toLowerCase()!=="cve" && type.toLowerCase()!=="nvd") return url
	if(url.includes(urlTemplate[type.toLowerCase()])) return url
	return urlTemplate[type.toLowerCase()]+url
}

const generateComponentpediaLink = (language, library, version) => {
  return "/components/live/"+language+"/"+encode(library)+"/"+version
}


const generateRegistryRequestLink = (language , library , version) => {
  if(language=="linux") return ""
  return `/processing_request.html?source=report&type=registry_url&create=true&useSDK=true&noProgress=true&name=${library}&version=${version}&language=${language}&custom_message=We are looking for ${library}:${version} in the ${language} registries...`
}

const encodeBlurry = (entry) => {
  if(!entry) return ""
  const letters = "abcdefghijklmnopqrstuvwxyz"
  const lettersLower = letters.split("")
  const lettersUpper = letters.toUpperCase().split("")
  const numbers = "0123456789"

  entry = entry.split(".").join("")
  entry = entry.split("_").join("")
  entry = entry.split(":").join("")
  entry = entry.split("-").join("")
  entry = entry.split("")

  for (let i = 0; i < entry.length; i++) {
    if (lettersLower.includes(entry[i])) {
      entry[i] = lettersLower[Math.floor(Math.random() * lettersLower.length)]
    }
    else if (lettersUpper.includes(entry[i])) {
      entry[i] = lettersUpper[Math.floor(Math.random() * lettersUpper.length)]
    }
    else if (numbers.includes(entry[i])) {
      entry[i] = numbers[Math.floor(Math.random() * numbers.length)]
    }
  }
  return entry.join("")

}


const scopes = {
  "all":"All dependencies",
  "prod": "Production"
}


module.exports = {randomUuid, capitalize,encode, processLink, generateComponentpediaLink, scopes, generateRegistryRequestLink, encodeBlurry}